{
  "citLinkSettingsDialog": {
    "title": "Settings",
    "testing": "Testing",
    "delete": "Delete parser",
    "type": "Type",
    "parameters": "Parameters",
    "fetcher": {
      "type": "Type"
    },
    "parser": {
      "type": "Type"
    },
    "ciTypeAttributes": "CI Type Attributes",
    "filter": "Filter",
    "scope": "Scope",
    "additionalAttributes": {
      "label": "Add. attributes",
      "name": "Name",
      "value": "Value"
    },
    "unsavedChanges": {
      "title": "Warning",
      "message": "There are unsaved changes!",
      "cancel": "Continue editing",
      "ok": "Cancel changes"
    },
    "tabs": {
      "fetcher": "Fetcher",
      "parser": "Parser",
      "filter": "Filter",
      "linkAttributes": "Link attributes"
    }
  },
  "citAttributeSettingsDialog": {
    "title": "Settings",
    "testing": "Testing",
    "delete": "Delete parser",
    "type": "Type",
    "parameters": "Parameters",
    "fetcher": {
      "type": "Type"
    },
    "parser": {
      "type": "Type"
    },
    "modifiers": "Modifiers",
    "unsavedChanges": {
      "title": "Warning",
      "message": "There are unsaved changes!",
      "cancel": "Continue editing",
      "ok": "Revert changes"
    },
    "tabs": {
      "fetcher": "Fetcher",
      "parser": "Parser",
      "modifiers": "Modifiers"
    }
  },
  "linkAttributesTab": {
    "settings": "Settings",
    "tabs": {
      "parser": "Parser"
    }
  },
  "linkAttributeSettingsDialog": {
    "title": "Settings"
  },
  "testingDialog": {
    "title": "Parser testing",
    "tabs": {
      "ci": "CI",
      "manually": "Manually"
    },
    "searchCi": "Search CI",
    "runTest": "Run test",
    "runResult": "Test results",
    "config": "Configuration",
    "error": {
      "ciNotSelected": "CI is not selected"
    }
  },
  "citPage": {
    "list": {
      "title": "CIT list",
      "empty": "CIT list is empty",
      "count": {
        "active": "Active CI",
        "deleted": "Deleted CI",
        "ownType": "Own type",
        "childTypes": "Child types"
      }
    },
    "item": {
      "empty": "Select CIT or create a new one",
      "newItem": "New CIT"
    },
    "export": {
      "title": "Export settings",
      "exclude_extend": "Link to external CI Type",
      "exclude_ext_link": "Links",
      "reset_ext_like_parent": "Parent settings"
    },
    "import": {
      "title": "Drag file here or click to select file",
      "message": "Attach signle file"
    },
    "select": {
      "title": "Select",
      "dependants": "Select dependants",
      "inherited": "Select parent elements",
      "children": "Select children elements",
      "links": "Select links",
      "selectRecursively": "Select recursively",
      "deselectRecursively": "Deselect recursively"
    },
    "likeParent": "Allow redefinition"
  },
  "citItem": {
    "title": "Type of configuration unit",
    "tab": {
      "cit": "CIT",
      "attributes": "Attributes",
      "links": "Available links",
      "healthIndicators": "Health indicators",
      "createCI": "CI list",
      "metrics": "Metrics",
      "variables": "Variables",
      "scripts": "Scripts",
      "actions": "Actions",
      "naming": "Naming",
      "identification": "Identification",
      "events": "Events",
      "deletePolicy": "Retention"
    },
    "deleteDialog": {
      "title": "Found CI in removed CIT",
      "messageTemplate": "For CIT \"{{type}}\" in the amount of CI \"{{count}}\""
    },
    "linksGraph": {
      "title": "CI type map",
      "summary": {
        "outgoing": "Outgoing links",
        "inherited": "inherited",
        "incoming": "Incoming links"
      },
      "ancestors": "Path to root",
      "inherited": "Inherited links",
      "descendants": "Descendants",
      "fit": "Fit graph",
      "png": "Save PNG",
      "collapse": "Collapse graph",
      "expand": "Expand graph",
      "openLinks": "Available links",
      "empty": "The CI type has no links. Add a link on the 'Available links' tab",
      "node": {
        "count": "CIs {{value}}",
        "total": "with descendants {{value}}",
        "deleted": "deleted {{value}}",
        "inheritors_one": "+{{count}} descendant",
        "inheritors_other": "+{{count}} descendants"
      },
      "tooltip": {
        "links": "CI links: {{value}}",
        "deleted": "Marked for deletion: {{value}}",
        "inheritedFrom": "Inherited from '{{ciType}}'",
        "sources": "Source and descendants",
        "inheritance": "Inheritance"
      },
      "legend": {
        "inheritance": "Inheritance",
        "inherited": "Inherited link"
      }
    }
  },
  "citTab": {
    "name": "Name",
    "label": "Label",
    "parent": "CIT parent",
    "icon": "Icon",
    "iconSize": {
      "label": "Icon size",
      "default": "Default",
      "small": "Small",
      "large": "Large"
    },
    "color": "Color",
    "changeReq": "Editing via a change request",
    "fetchConfig": "Fetch configuration",
    "scriptExecutor": "Script executor"
  },
  "attributesTab": {
    "parser": "Parser",
    "attribute": "Attribute",
    "modifiers": {
      "editable": "Editable",
      "hidden": "Hidden",
      "required": "Required",
      "save_history": "Save history"
    },
    "sections": {
      "modifiers": "Modifiers",
      "parser": "Parser",
      "fetcher": "Fetcher",
      "attributes": "Attributes"
    },
    "cols": {
      "name": "Name",
      "modifiers": "Modifiers"
    },
    "checkParserTooltip": "Check parser validity",
    "getParserDescription": "Get full description",
    "addDataToCheckValidity": "Add data to check validity",
    "result": "Result"
  },
  "linksTab": {
    "linkType": "Link type",
    "count": "Active",
    "del_count": "Deleted",
    "numberOfLinks": "Number of links",
    "citType": "CIT type",
    "settings": "Settings",
    "linkList": "Links list",
    "link": "Link",
    "parser": "Parser",
    "attribute": "Attribute",
    "modifiers": {
      "editable": "Editable",
      "hidden": "Hidden",
      "required": "Required",
      "save_history": "Save history"
    },
    "validation": {
      "duplicatedName": "Duplicated name",
      "unconfiguredParser": "Parser not configured"
    },
    "sections": {
      "modifiers": "Modifiers",
      "parser": "Parser",
      "fetcher": "Fetcher",
      "filter": "Filter",
      "attributes": "Attributes"
    },
    "cols": {
      "attributes": "Attributes",
      "modifiers": "Modifiers"
    },
    "checkParserTooltip": "Check parser validity",
    "addDataToCheckValidity": "Add data to check validity",
    "result": "Result"
  },
  "attributeSelectDialog": {
    "title": "Add attribute",
    "empty": "Attribute list is empty"
  },
  "variablesTab": {
    "table": {
      "name": "Name",
      "type": "Type",
      "description": "Description"
    }
  },
  "variableDialog": {
    "title": "Variable",
    "name": "Name",
    "type": "Type",
    "description": "Description"
  },
  "scriptsTab": {
    "types": {
      "ci": "CI",
      "attribute": "Attributes",
      "connection": "Links",
      "others": "Others"
    },
    "items": {
      "type": "Type",
      "name": "Name",
      "managed_attribute": "Managed attribute",
      "dst_type_id": "Destination",
      "link_id": "Link type",
      "description": "Description",
      "action": "Action",
      "script": "Script",
      "isRollback": "Separate rollback script",
      "scriptRollback": "Rollback script"
    },
    "segments": {
      "script": "script",
      "code": "code",
      "noRollback": "no rollback"
    },
    "scriptDialog": {
      "title": "Script",
      "add": "create",
      "update": "update",
      "resultAttribute": "The attribute in which the result of the script execution will be saved"
    }
  },
  "actionsTab": {
    "name": "Class name"
  },
  "actionDialog": {
    "title": "Action",
    "name": "Class",
    "settings": "Settings"
  },
  "namingTab": {
    "template": "Template",
    "updNames": "Update CI names",
    "hint": {
      "title": "Template example"
    }
  },
  "identificationTab": {
    "or": "OR",
    "and": "AND",
    "addAttributes": "Add attributes",
    "legend": "Identification rules"
  },
  "eventDialog": {
    "title": "Event",
    "script": "Script",
    "event": "Event"
  },
  "metricsTab": {
    "dialogTitle": "Metric setting",
    "connectMetric": "Link the metric to CI",
    "disconnectMetric": "Unlink the metric from CI",
    "items": {
      "name": "Name",
      "nameValidation": "Name must contain only lowercase Latin letters, numbers or \"_\"",
      "job": "Jobs",
      "description": "Description",
      "module": "Module",
      "target": "Goal formation template",
      "filter": "Filter",
      "forceDeleteWarning": "Delete ot this metric would affect on following Health Indicators",
      "targetsCount": "Targets count",
      "failedTargetsCount": "Generation errors"
    }
  },
  "hiTab": {
    "dialogTitle": "Health indicator",
    "nodeIdHint": "The settings apply to a TQL edge of the template. Every edge has its own number (ID) — rules and templates address the edge by it.",
    "nodeReferenceHint": "The chosen edge is addressed in rules and templates as {{reference}}.",
    "dialogSelectDescription": "Select TQL Edge on which instances HIs would be made",
    "connectHi": "Link the indicator to CI",
    "disconnectHi": "Unlink the indicator from CI",
    "addHIDepends": "Add a related indicator",
    "items": {
      "name": "Name of health indicator",
      "metric": "Metric",
      "relativeMetric": "Relative metric",
      "hi": "Health indicator",
      "hiDescription": "Select HI the values ​​that will influence the calculated indicator",
      "hit": "Health indicator's type",
      "hiSource": "Source of health indicator",
      "hiSetting": "Health indicator settings",
      "type": "Type",
      "source": "Source of health indicator's values",
      "rule": "Rule",
      "expression": "Expression",
      "percentile": "Percentile",
      "useFilter": "Use filter",
      "filter": "Filter",
      "filterDescription": "The selected HI can be used in several monitoring templates. You can limit the source of the calculated HI values ​​by selecting specific monitoring templates. An empty Filter field means that the source of the calculated HI values ​​will be all KEs of the selected TQL node on which the specified HI is configured.",
      "tabsDescription": "The source of values ​​for the calculated health indicator are other indicators defined on adjacent CI. Select the TQL node to define adjacent CI",
      "exporter": "Exporter",
      "defaultStatus": "Default status",
      "undefinedLabel": "edge is not defined",
      "removedNodeLabel": "edge is removed from TQL",
      "noMetriclabel": "related metric is deleted",
      "addMore": "Add more",
      "chooseSource": "Choose source",
      "chooseSourceTitle": "Choose the health indicator source",
      "subscriptions": "Subscriptions",
      "hisCount": "HIs count",
      "failedHintsCount": "Generation errors",
      "templateLabel": "TQL Nodes of Monitoring Template",
      "alertRuleLabel": "Alerting rule",
      "alertRuleConfigLabel": "Alerting rule configuration",
      "ciHintRule": "ci_hint rule",
      "hiHint": "hi_hint",
      "ruleAgent": "Rule processing agent",
      "status": "Status",
      "tqlEdge": "TQL edge",
      "tqlEdgePlaceholder": "Edge name or number",
      "sourceNode": "Source TQL edge",
      "sourceNodeDescription": "Edges already added as sources and the edge of the indicator itself are hidden from the list."
    },
    "media": {
      "title": "Media source",
      "connector": "Connection",
      "connectorDescription": "Select an S3 connection.",
      "ruleType": "Path selection",
      "string": "String",
      "attribute": "Attribute",
      "resourcePath": "Resource path",
      "attributeName": "CI attribute name",
      "attributeDescription": "The path is resolved once from the CI attribute value and stored in the indicator",
      "timePrefix": "Time layout",
      "timePrefixDescription": "Resolved at request time using the interval window",
      "fileName": "Time in file name",
      "margin": "Window margin",
      "timezone": "Time zone",
      "timezoneDescription": "UTC offset from −12:00 to +14:00 in ±HH:MM format. Minutes: 00, 30 or 45.",
      "secondsSuffix": " s",
      "validation": "Fill in the connection, resource path, time layout and file name. The margin must be an integer from 0 to 3600 seconds. Set a time zone in ±HH:MM format with minutes 00, 30 or 45, from −12:00 to +14:00."
    },
    "subscriptionDialogTitle": "HI Subscriptions",
    "subscriptionFields": {
      "severity": "Select severity types"
    },
    "severityMapping": {
      "title": "Severity mapping",
      "description": "Configure severity change rules for calculated HIs",
      "empty": "No rules configured",
      "rule": "Rule {{number}}",
      "source": "If value equals",
      "target": "Set severity",
      "delete": "Delete rule",
      "validation": "Check severity mapping rules"
    },
    "notSet": "Not set",
    "deleteDialog": {
      "message": "Delete health indicator binding <strong>\"{{hiTypeLabel}}\"</strong>. Continue?",
      "forceCheckbox": "Delete <strong>disabled</strong> bindings in calculated HIs",
      "disabledHint": "Only a disabled link can be deleted. Switch it off in the \"Status\" column first."
    },
    "propagation": {
      "title": "Status propagation",
      "source": "Source",
      "receiver": "Receiver",
      "receiverNode": "TQL node — receiver",
      "edge": "TQL link",
      "choose": "Choose a link",
      "chooseDescription": "There are multiple links between these nodes. Choose a link for this rule.",
      "automatic": "Selected automatically",
      "along_link": "Along the TQL link direction",
      "against_link": "Against the TQL link direction",
      "pending": "The direction will appear after a link is selected.",
      "ambiguous": "Choose one of the matching TQL links.",
      "missing": "There is no matching direct TQL link between the selected nodes.",
      "stale": "The saved link no longer matches or was removed from TQL. Choose another link.",
      "linkSettings": "Link settings in CI type",
      "showTql": "Show in TQL",
      "limits": "Limits: {{source}} → {{target}}",
      "variant": "Option {{number}}"
    }
  },
  "attributesPage": {
    "title": "Attributes",
    "table": {
      "name": "System name",
      "label": "Name",
      "key": "key",
      "type": "Type",
      "systemFunction": "Target use",
      "tags": "Tags"
    }
  },
  "attributeDialog": {
    "title": "Attribute",
    "valueSchemaEditor": {
      "editor": {
        "title": "Editor",
        "schema": "Schema",
        "uiSchema": "UI Schema"
      },
      "preview": {
        "title": "Preview"
      },
      "template": {
        "title": "Template",
        "saveTemplate": "Save as template",
        "group": "Group",
        "name": "Name"
      }
    },
    "form": {
      "name": "Name",
      "label": "Label",
      "key": "Key",
      "type": "Type",
      "preview": "Preview",
      "systemFunctionWarning": "This attribute is used by the system and cannot be edited.",
      "valueSchema": "Value schema",
      "uiEditor": "Editor",
      "requiredField": "Required field",
      "emptyType": "Select type",
      "invalidKey": "Key must only have latin lowercase characters, numbers or underscore",
      "modifiers": {
        "label": "Modifies",
        "blocked": "Prevent user from editing",
        "required": "Required"
      },
      "schemaPresets": {
        "default": {
          "label": "Default"
        },
        "string": {
          "label": "String"
        },
        "number": {
          "label": "Number"
        },
        "string_list": {
          "label": "String list"
        },
        "date-time": {
          "label": "Datetime"
        },
        "textarea": {
          "label": "Textarea"
        },
        "float": {
          "label": "Float number",
          "minimum": "Minimum",
          "maximum": "Maximum"
        },
        "integer": {
          "label": "Integer number",
          "minimum": "Minimum",
          "maximum": "Maximum"
        },
        "slider": {
          "label": "Slider",
          "minimum": "Minumum",
          "maximum": "Maximum",
          "step": "Step"
        },
        "updown": {
          "label": "Arrows",
          "minimum": "Minumum",
          "maximum": "Maximum",
          "step": "Step"
        },
        "codeEditor": {
          "label": "Code editor"
        },
        "color": {
          "label": "Color"
        },
        "json": {
          "label": "JSONB"
        },
        "form": {
          "label": "Form"
        },
        "array": {
          "label": "Array",
          "itemSchema": "Item schema",
          "uiItemSchema": "UI item schema",
          "withModal": "With Modal",
          "typeError": "Property 'type' must be 'object'",
          "propertiesError": "Value of 'properties' must be filled"
        },
        "schema": {
          "label": "Schema"
        },
        "file": {
          "label": "File"
        },
        "password": {
          "label": "Password"
        },
        "ip": {
          "label": "IP address"
        },
        "boolean": {
          "label": "Boolean"
        },
        "radio": {
          "label": "Radio",
          "true": "True label",
          "false": "False label"
        }
      },
      "uiTypes": {
        "textarea": "Text area",
        "editor": "Code editor",
        "schema": "Schema settings"
      }
    }
  },
  "healthIndicatorsPage": {
    "title": "Health indicators",
    "table": {
      "name": "System name",
      "label": "Name",
      "tags": "Tags",
      "template": "Template",
      "templateList": "List of templates",
      "description": "Description",
      "filter": "Filter"
    },
    "template": {
      "true": "True",
      "false": "-",
      "empty": "Empty"
    },
    "deleteDialog": {
      "message": "Deleting health indicator <strong>\"{{hiTypeLabel}}\"</strong>. Continue?",
      "forceCheckbox": "Delete <strong>disabled</strong> bindings in monitoring templates"
    }
  },
  "healthIndicatorDialog": {
    "title": "Health indicator",
    "form": {
      "name": "Name",
      "label": "Label",
      "config": "Template",
      "description": "Description",
      "severity": "Log event severity field",
      "hiOptions": "Health indicator options",
      "parser": "Log severity parser"
    }
  },
  "userPage": {
    "title": "Additional user fields",
    "info": "In addition to the standard fields (last name, first name, patronymic, login, avatar), the following fields will be available to the user:",
    "form": {
      "title": "Title",
      "type": "Type"
    }
  },
  "userCustomFieldDialog": {
    "title": "Additional user field",
    "label": "Name",
    "name": "Key",
    "type": "Type"
  },
  "ldapPage": {
    "form": {
      "createTitle": "New LDAP connection",
      "sections": {
        "basicInfo": "Basic information",
        "serverCredentials": "Server credentials",
        "searchScopes": "Search scopes",
        "additionalSettings": "Additional settings",
        "attributeMapping": "Attribute mapping"
      },
      "displayName": {
        "label": "Display name",
        "description": "Name that will be displayed to users on the login page",
        "placeholder": "My LDAP"
      },
      "name": {
        "label": "Name",
        "description": "Unique connection identifier. Used internally. Cannot be changed after saving.",
        "placeholder": "my_ldap"
      },
      "host": {
        "label": "Host"
      },
      "port": {
        "label": "Port"
      },
      "protocol": {
        "label": "Protocol",
        "placeholder": "No encryption"
      },
      "verifySsl": {
        "label": "Verify SSL certificate",
        "description": "Disabling certificate verification is allowed only in test environments. Not recommended for production."
      },
      "anonymous": {
        "label": "Anonymous connection"
      },
      "baseDn": {
        "label": "Base DN"
      },
      "userDns": {
        "label": "User DNs",
        "itemLabel": "User DN"
      },
      "groupDns": {
        "label": "Group DNs",
        "itemLabel": "Group DN"
      },
      "userTemplate": {
        "label": "User search template",
        "description": "Example: (sAMAccountName={login})."
      },
      "groupTemplate": {
        "label": "Group search template"
      },
      "active": {
        "label": "Activate connection",
        "description": "When enabled, this connection can be used by the system to search and authenticate users."
      },
      "loginExpression": {
        "label": "Login JQ expression",
        "placeholder": ".data[0].attributes.sAMAccountName[0]",
        "description": "JQ expression applied to an object with the keys data (directory entries found, where attribute values are arrays of strings) and groups (user groups). Result is stored in login and used to match users with existing accounts."
      }
    },
    "test": {
      "button": "Test connection",
      "credentialsTitle": "Test credentials",
      "error": "Error",
      "loading": "Testing connection…",
      "successTitle": "Connection test succeeded",
      "failureTitle": "Connection test failed",
      "saveFirst": "Save the connection first",
      "credentialsRequired": "Enter login and password to run the test",
      "popupBlocked": "Popup blocked",
      "popupBlockedMessage": "Allow popups for this site or the test will open in the current tab.",
      "backToSettings": "Back to settings",
      "closeWindow": "Close window",
      "noKey": "Test key not found",
      "noPayload": "Test payload not found (refresh and try again)",
      "unknownError": "Unknown error",
      "errorDetails": "Details",
      "mappedUser": "Mapped user",
      "rawData": "Raw data",
      "fullResult": "Full result",
      "success": "Connection established",
      "failed": "Failed to establish connection"
    },
    "attributeMapping": {
      "addButton": "Add",
      "editRule": "Edit rule",
      "table": {
        "name": "Name",
        "expression": "Expression",
        "syncType": "Sync type"
      },
      "syncType": {
        "DISABLE": "Sync disabled",
        "PERIODIC": "Update periodically",
        "ON_CREATE": "Only on user create",
        "IF_EXIST": "Update only if value exists"
      },
      "validation": {
        "nameRequired": "Attribute name is required",
        "syncTypeRequired": "Sync type is required",
        "expressionRequired": "Expression is required"
      },
      "addModal": {
        "title": "Add attributes",
        "searchPlaceholder": "Search",
        "selectAll": "Select all",
        "noAttributes": "No data",
        "apply": "Apply"
      },
      "editModal": {
        "title": "Attribute settings: {{attribute}}",
        "description": "Expression to get attribute value from LDAP user record (similar to JQ/used engine).",
        "syncTypeLabel": "Sync type",
        "syncTypeDescription": "Defines when and how to update attribute value from LDAP."
      }
    },
    "syncTab": {
      "title": "Sync attributes",
      "addTitle": "Add configuration",
      "columns": {
        "attribute": "Attribute",
        "syncType": "Sync type",
        "status": {
          "label": "Status",
          "active": "Active",
          "inactive": "Inactive"
        },
        "type": {
          "label": "Type",
          "base": "Base",
          "optional": "Optional"
        }
      },
      "form": {
        "name": {
          "label": "User attribute",
          "description": "User attribute, value which will be filled on LDAP sync"
        },
        "active": {
          "label": "Enable sync",
          "description": "If enabled, then user attribute will be filled on LDAP sync",
          "error": "Sync can't be enabled with empty Expression"
        },
        "type": {
          "label": "Sync type",
          "description": "user - user attribute will be filled on LDAP sync. group - user will be searched by regular expression",
          "user": "User",
          "group": "Group"
        },
        "user": {
          "expression": {
            "label": "Expression",
            "description": "LDAP query for user search"
          }
        },
        "group": {
          "expression": {
            "label": "Expression",
            "description": "Regular expression for group search"
          },
          "true_action": {
            "label": "Method for filling the user attribute value",
            "description": "LITERAL - user attribute will be filled on LDAP sync, REGEX - user will be searched by regular expression",
            "value": {
              "literal": "Value which will be filled on LDAP sync",
              "regex": "Regular expression for user search"
            }
          },
          "false_action": {
            "label": "Value for filling the user attribute in case of absence of the group",
            "description": "User attribute will be filled with this value in case of absence of the group"
          }
        }
      }
    },
    "list": {
      "title": "LDAP list",
      "empty": "LDAP list is empty",
      "newElement": "New LDAP"
    },
    "tabs": {
      "connection": "Connection",
      "sync": "Synchronization"
    },
    "item": {
      "empty": "Select LDAP or create a new one",
      "title": "LDAP configuration"
    },
    "connectionTab": {
      "form": {
        "useConnection": "Use connection for searching users",
        "checkConnection": "Check connection",
        "connectionSuccessMsg": "Connection established",
        "title": "Title",
        "active": "Active",
        "inactive": "Inactive",
        "host": "Host",
        "port": "Port",
        "anonymous_connection": "Anonymous connection",
        "ignore_cert": "Accept unverified certificates",
        "no_encryption": "No encryption",
        "protocol": "Protocol",
        "baseDn": "BaseDN",
        "surname": "Last name",
        "name": "First name",
        "patronymic": "Middle name",
        "login": "Login",
        "email": "Email",
        "avatar": "Avatar",
        "status": "Status",
        "userCredentials": "User credentials",
        "userSearchTemplate": "User search template",
        "groupSearchTemplate": "Group search template",
        "userSearchScopes": "User search scopes",
        "serverDetails": "Server details"
      }
    },
    "select": {
      "user": "User",
      "belongs": "Belongs to the group",
      "memberOf": "There is a group"
    },
    "table": {
      "system": "System",
      "ldap": "LDAP",
      "type": "Type"
    }
  },
  "prometheusPage": {
    "title": "Prometheus",
    "reloadButton": "Reload Prometheus",
    "controlModeLabel": "Configuration control mode",
    "tabs": {
      "prometheus": "Prometheus",
      "alertManager": "Alert manager",
      "alerts": "Alert rules",
      "targets": "targets",
      "exporters": "Exporters"
    },
    "labels": {
      "alerts": "Alerts configutation",
      "targets": "Targets configutation",
      "exporters": "Exporters configutation"
    }
  },
  "oidcPage": {
    "list": {
      "title": "OIDC Providers List",
      "empty": "OIDC providers list is empty",
      "newElement": "New OIDC Provider"
    },
    "form": {
      "createTitle": "Create new OIDC connection",
      "editTitle": "Edit connection: {{name}}",
      "sections": {
        "basicInfo": "Basic Information",
        "credentials": "Credentials",
        "endpoints": "Endpoints Configuration",
        "endpointsAdvanced": "Advanced Settings",
        "additionalSettings": "Additional Settings",
        "attributeMapping": "Attribute Mapping"
      },
      "displayName": {
        "label": "Display Name",
        "description": "Name that will be displayed to users on the login page",
        "placeholder": "Google"
      },
      "name": {
        "label": "Name",
        "description": "Unique connection identifier. Used internally. Cannot be changed after saving.",
        "placeholder": "google"
      },
      "nameValidation": "Allowed characters: lowercase letters, digits and underscore. Must start with a letter.",
      "authorizeUrl": {
        "label": "Authorization URL (Auth URL)",
        "description": "OIDC provider's authorization endpoint URL",
        "placeholder": "https://accounts.google.com/o/oauth2/v2/auth"
      },
      "accessTokenUrl": {
        "label": "Token URL (Token URL)",
        "description": "Access token endpoint URL",
        "placeholder": "https://oauth2.googleapis.com/token"
      },
      "userinfoEndpoint": {
        "label": "UserInfo URL (UserInfo)",
        "description": "User information endpoint URL",
        "placeholder": "https://openidconnect.googleapis.com/v1/userinfo"
      },
      "serverMetadataUrl": {
        "label": "Discovery URL (.well-known)",
        "description": "URL for obtaining OIDC provider metadata (discovery endpoint)",
        "placeholder": "https://accounts.google.com/.well-known/openid-configuration"
      },
      "tokenEndpointAuthMethod": {
        "label": "Authentication Method",
        "description": "Authentication method when requesting token",
        "placeholder": "Select method...",
        "options": {
          "client_secret_basic": "Basic Auth",
          "client_secret_post": "POST Body",
          "client_secret_jwt": "JWT",
          "private_key_jwt": "Private Key",
          "none": "Public client"
        }
      },
      "clientId": {
        "label": "Client ID",
        "description": "Client identifier obtained when registering the application with the OIDC provider",
        "placeholder": "Enter client ID"
      },
      "clientSecret": {
        "label": "Client Secret",
        "description": "Client secret obtained from the OIDC provider",
        "placeholderEdit": "Leave empty to keep unchanged"
      },
      "scope": {
        "label": "Scopes",
        "description": "Requested scopes separated by space. openid is required."
      },
      "verifySsl": {
        "label": "Verify SSL Certificate",
        "description": "Disable only if you are using self-signed certificates in a test environment. Not recommended for production."
      },
      "active": {
        "label": "Activate Connection",
        "description": "Makes this login method available to users on the login page"
      },
      "toggleAdvancedEndpoints": "Advanced Settings",
      "showAdvancedEndpoints": "Show Advanced Settings",
      "hideAdvancedEndpoints": "Hide Advanced Settings",
      "loginExpression": {
        "label": "JQ expression for login",
        "description": "JQ expression applied to OIDC UserInfo. The result is stored in the login field and used to match users in the system (default: .email).",
        "placeholder": ".email"
      }
    },
    "attributeMapping": {
      "title": "Attribute Mapping",
      "description": "Configure rules for extracting user attribute values from the OIDC provider's response",
      "addButton": "Add",
      "table": {
        "name": "Name",
        "expression": "Expression",
        "syncType": "Sync Type",
        "actions": "Actions"
      },
      "syncType": {
        "DISABLE": "Synchronization disabled",
        "PERIODIC": "Update periodically",
        "ON_CREATE": "Only when creating user",
        "IF_EXIST": "Update only if value received from IdP"
      },
      "hasRule": "Rule configured",
      "editRule": "Edit Rule",
      "deleteConfirm": {
        "title": "Delete Attribute",
        "message": "Are you sure you want to delete the attribute \"{{attribute}}\"?"
      },
      "addModal": {
        "title": "Add Attribute",
        "searchPlaceholder": "Search attributes...",
        "selectAll": "Select All",
        "noAttributes": "No available attributes",
        "apply": "Apply"
      },
      "editModal": {
        "title": "Edit rule for attribute: {{attribute}}",
        "description": "Enter a jq expression to extract the value from the user_info JSON object received from the OIDC provider. The root . represents the entire user_info object.",
        "examples": "Examples:",
        "example1": "Simple field: .email",
        "example2": "Nested field: .profile.first_name",
        "example3": "Concatenation: .given_name + \" \" + .family_name",
        "example4": "Default value: .nickname // .preferred_username",
        "syncTypeLabel": "Sync Type",
        "syncTypeDescription": "Select how to synchronize the attribute from IdP"
      }
    },
    "test": {
      "button": "Test Connection",
      "title": "OIDC Connection Test Results",
      "loading": "Loading test results...",
      "error": "Error",
      "noKey": "Missing key to retrieve test results. Please retry testing.",
      "unknownError": "Unknown error",
      "unknownProvider": "Unknown provider",
      "successTitle": "Test passed successfully",
      "failureTitle": "Test failed with error",
      "successMessage": "Authentication via {{provider}} provider was successful. Field mapping is correct.",
      "errorDetails": "Error details",
      "mappedUser": "Mapped user data",
      "rawData": "Raw data from OIDC provider",
      "fullResult": "Full result",
      "closeWindowHint": "You can safely close this window.",
      "saveFirst": "You need to save the provider settings first before testing the connection.",
      "backToSettings": "Back to Settings",
      "closeWindow": "Close Window",
      "popupBlocked": "Popup Blocked",
      "popupBlockedMessage": "Allow popups for this site or testing will be performed in the current window",
      "testingProvider": "Testing provider {{provider}}...",
      "connectionFailed": "OIDC Provider Connection Error",
      "errorStatus": "Status: {{status}}",
      "providerName": "Provider",
      "errorType": "Error type"
    }
  },
  "monitoringPage": {
    "exporters": "Exporters",
    "exporter": "Exporter",
    "exportersList": {
      "title": "Exporters list",
      "empty": "Exporters list is empty",
      "newElement": "New exporter"
    },
    "modules": "Modules",
    "module": "Module",
    "withoutModule": "Without module",
    "jobs": "Jobs",
    "job": "Job",
    "editManually": "Edit manually",
    "incorrectFormat": "Incorrect format",
    "incorrectNameFormat": "The name must start with a lowercase letter and contain only lowercase letters, numbers, and underscores.",
    "endpointForReload": "Endpoint for reload exporter configuration",
    "redisKey": "Redis key",
    "copyToClipboard": "Copy to clipboard",
    "copyEnabled": "The connection to the site is not secure, the key cannot be copied to the clipboard",
    "copiedSuccessfully": "Copied successfully",
    "list": {
      "title": "Template list",
      "empty": "Template list is empty",
      "newElement": "New template"
    },
    "exportersModal": {
      "control_mode": "Configuration source",
      "mode": {
        "no_control": "Local",
        "redis": "Redis",
        "container": "Docker container"
      },
      "test_connection": "Check",
      "docker_url": "Docker address",
      "container": "Container",
      "success": "Success",
      "errror": "Errror",
      "endpoint": "HTTP endpoint",
      "config_path": "Configuration file path",
      "show_logs": "Container logs",
      "apply_success": "Configuration applied",
      "connection_success": "Connected",
      "connection_error": "Connection failed",
      "container_not_in_list": "Container not in list",
      "command": "Command",
      "update_method": {
        "endpoint": "Reload via HTTP",
        "command": "Command in container",
        "restart": "Restart container"
      },
      "tabs": {
        "exporter": "Exporter",
        "source": "Configuration source settings"
      },
      "source": {
        "localTitle": "Source: Local",
        "localDescription": "The configuration is stored only in this management interface. Transferring and applying the file on the exporter side is up to the user.",
        "redisTitle": "Source: Redis",
        "redisKey": "Redis key",
        "redisKeyDescription": "Configuration will be stored in Redis under this key",
        "containerTitle": "Source: Docker container",
        "connectionSection": "Connection",
        "fileSection": "Target file",
        "updateSection": "Apply method",
        "endpointHint": "After writing the configuration, an HTTP request will be sent to apply changes.",
        "commandHint": "The command will be executed in the container after writing the configuration.",
        "restartHint": "After writing the configuration, the container will be restarted."
      },
      "actions": {
        "saveAndApply": "Save and apply",
        "apply": "Apply"
      },
      "compare": {
        "containerTitle": "Configuration from container",
        "redisTitle": "Configuration from Redis",
        "containerDescription": "Below is the configuration read from the container. You can save it as the current one.",
        "redisDescription": "Below is the configuration read from Redis. You can save it as the current one.",
        "sourcePath": "Source",
        "container": "Container",
        "current": "Current configuration",
        "fromContainer": "Configuration from container",
        "fromRedis": "Configuration from Redis",
        "applyContainer": "Save configuration from container as current",
        "applyRedis": "Save configuration from Redis as current"
      }
    },
    "areas": {
      "name": "System name",
      "nameDescription": "Used internally by the system",
      "label": "Label",
      "depends": "Depends",
      "template": "Template",
      "key": "Key",
      "config": "Configuration"
    },
    "editWarningTitle": "Name on job is changed",
    "editWarningText": "In the associated metrics of existing monitoring templates, the task will be displayed by its new name"
  },
  "pagesSettingsPage": {
    "list": {
      "title": "Configurations",
      "empty": "Configurations list is empty"
    },
    "item": {
      "empty": "Select configuration or create one"
    }
  },
  "pagesSettingsItem": {
    "title": "Page",
    "config": {
      "name": "Name",
      "nameResolution": "Resolution name",
      "keyPath": "Key path",
      "width": "Screen width",
      "height": "Screen height",
      "fixedHeight": "Fixed height",
      "layout": "Layout",
      "preview": "Предпросмотр"
    }
  },
  "mainPageLayout": {
    "device-status": "Device status",
    "alarms": "Alarms",
    "attacks": "Attacks",
    "device-utilization": "Device utilization",
    "fake-1": "fake-1",
    "fake-2": "fake-2"
  },
  "pageWidgetConfigDialog": {
    "title": "Widget setting",
    "height": "Height (%)"
  },
  "enrichmentSettingsPage": {
    "list": {
      "title": "Enrichment plans",
      "empty": "Plan list is empty",
      "group": "Group",
      "plan": "Plan"
    },
    "modal": {
      "firstStep": {
        "label": "Upload",
        "description": "Attach JSON file"
      },
      "secondStep": {
        "label": "Analyze",
        "description": "Confirm actions",
        "title": "Configuration analysis results"
      },
      "thirdStep": {
        "label": "Result",
        "description": "Monitoring progress",
        "title": "Import completed",
        "errorTitle": "Import canceled"
      }
    },
    "item": {
      "empty": "Choose a plan or create a new one",
      "group": "Group",
      "plan": "CPM enrichment plan",
      "name": "Name",
      "label": "Label",
      "parent": "Parent group",
      "cron": {
        "name": "Start frequency",
        "description": "The launch frequency is specified as a CRON expression. The line consists of 5 cells separated by spaces. The cells set the execution time (minute, hour, day, month, day of the week), they can contain a number, a list of numbers separated by commas, a range of numbers separated by a hyphen, the characters “*” or “/”.",
        "code": "* * * * * command being executed\n- - - - -\n| | | | |\n| | | | ----- month (1-12)\n| | | ------- day (1-31)\n| | --------- day of the week (0-6)\n| ----------- hour (0-23)\n------------- minute (0-59)",
        "errorMsg": "Incorrect expression"
      },
      "active": "Active",
      "filter": "Filter"
    }
  },
  "actionPlansSettingsPage": {
    "list": {
      "title": "Action plans",
      "empty": "Plan list is empty",
      "group": "Group",
      "plan": "Plan"
    },
    "item": {
      "empty": "Choose a plan or create a new one",
      "group": "Group",
      "plan": "Action plan",
      "name": "Name",
      "type": "Type",
      "multiply": "Multiply",
      "parent": "Parent group",
      "cron": {
        "name": "Start frequency",
        "description": "The launch frequency is specified as a CRON expression. The line consists of 5 cells separated by spaces. The cells set the execution time (minute, hour, day, month, day of the week), they can contain a number, a list of numbers separated by commas, a range of numbers separated by a hyphen, the characters “*” or “/”.",
        "code": "* * * * * command being executed\n- - - - -\n| | | | |\n| | | | ----- month (1-12)\n| | | ------- day (1-31)\n| | --------- day of the week (0-6)\n| ----------- hour (0-23)\n------------- minute (0-59)",
        "errorMsg": "Incorrect expression"
      },
      "active": "Active",
      "filter": "Filter",
      "actions": "Actions",
      "vars": "Variables",
      "var": "Variable",
      "saveToVars": "Write the result of execution to variables",
      "saveFilterResultToVars": "Write the filter result to variables",
      "multipleCi": "Return a list",
      "value": "Value",
      "attribute": "Template",
      "types": {
        "search": "Search",
        "ci_add": "Add CI"
      }
    }
  },
  "globalSettingsPage": {
    "title": "Global settings",
    "services": {
      "auth": "Authorization",
      "srm": "SRM",
      "monitoring": "Monitoring",
      "notification": "Notification",
      "docker_tool": "Docker tool",
      "task_tool": "Task tool"
    },
    "columns": {
      "name": "Name",
      "valueType": "Data type",
      "description": "Description",
      "value": "Value",
      "actions": "Actions",
      "status": "Status",
      "tqlEdge": "TQL edge"
    }
  },
  "schedulesPage": {
    "title": "Scheduled tasks",
    "services": {
      "srm": "SRM",
      "monitoring": "Monitoring"
    },
    "columns": {
      "task": "Task",
      "systemName": "System name",
      "schedule": "Schedule"
    },
    "dialog": {
      "cron": {
        "name": "Schedule",
        "description": "The schedule is a cron expression of five space separated fields: minute, hour, day of month, month, day of week. A field accepts a number, a comma separated list, a dash separated range and the «*» and «/» characters.",
        "code": "* * * * * command to run\n- - - - -\n| | | | |\n| | | | ----- day of week (0—6, 0 — Sunday)\n| | | ------- month (1—12)\n| | --------- day of month (1—31)\n| ----------- hour (0—23)\n------------- minute (0—59)",
        "errorMsg": "Invalid expression"
      },
      "reset": "Default",
      "resetHint": "No default value is defined for this task"
    },
    "tasks": {
      "srm": {
        "send_outbox_events": "Send pending SRM events to the message broker",
        "check_tqls": "Check and refresh saved TQL queries",
        "clean_orphan_files": "Delete files that are no longer referenced",
        "clean_users": "Delete objects that belonged to removed users",
        "clean_expires_cookies": "Delete expired cookies from the fetcher storage",
        "delete_old_statistics": "Delete outdated enrichment statistics records",
        "delete_marked_cis": "Physical deletion of CIs marked for deletion",
        "clean_bulk_import_jobs": "Delete outdated bulk CI import jobs"
      },
      "monitoring": {
        "send_outbox_events": "Send pending monitoring events to the message broker",
        "hi_outbox": "Process the health indicator recalculation queue",
        "alert_repair": "Close alerts whose validity period has expired",
        "history_cleanup": "Delete health indicator and alert history older than the retention period",
        "keep_alive_template_tql": "Keep TQL queries of monitoring templates alive",
        "check_hi_history": "Check consistency of health indicators and their history"
      }
    }
  },
  "systemSettingsPage": {
    "name": "Name",
    "empty": "Choose daemon or create new one",
    "title": "Docker daemon's list",
    "tableTitle": "Components",
    "itemTitle": "Docker daemon",
    "newElement": "New daemon",
    "tabs": {
      "daemon": "Connection settings",
      "components": "Docker контейнеры"
    },
    "daemon": {
      "url_created": "URL created",
      "url_changed": "URL changed",
      "connection_established": "Connection established",
      "connection_failed": "Failed to establish connection"
    },
    "columns": {
      "name": "Name",
      "container_id": "Container id",
      "image": "Image",
      "status": "Status",
      "created": "Created"
    }
  },
  "notificationsSettingsPage": {
    "time_interval": {
      "empty": "Choose interval or create new one",
      "title": "Time interval's list",
      "itemTitle": "Time interval",
      "newElement": "New time interval",
      "nameField": "Interval Name"
    },
    "senders": {
      "empty": "Choose sender or create new one",
      "title": "Sender's list",
      "itemTitle": "Sender",
      "newElement": "New sender",
      "nameField": "Sender Name",
      "type": "Sender Type",
      "active": "Is active"
    }
  },
  "attributesCompletion": {
    "attributes": "Attributes",
    "target_attributes": "Target attributes",
    "link_attributes": "Link attributes",
    "fields": "Metric fields"
  },
  "vmagentsPage": {
    "listEmpty": "Agents list is empty",
    "listTitle": "Agents list",
    "formFields": {
      "name": "System name",
      "label": "Label",
      "enabled": "Enable configuration rebuilding",
      "validationType": "Validation type",
      "jobs": "Jobs",
      "tags": "Tags",
      "config": "Configuration",
      "apiBaseUrl": "API base url",
      "apiBaseUrlHint": "Monitoring address reachable from this instance network, formatted as http(s)://<host>[:<port>][/<path>]. If empty, the common system address is used."
    },
    "notification": {
      "title": "The task list has been reset",
      "content": "Changing the validation type clears the list of selected tasks. Please select tasks again."
    }
  },
  "vmalertsPage": {
    "listEmpty": "Agents list is empty",
    "listTitle": "Agents list",
    "openTab": "Open in new tab",
    "formFields": {
      "name": "System name",
      "label": "Display name",
      "tags": "Tags",
      "config": "Configuration",
      "managed": "Managed",
      "url": "Configuration URI",
      "alertUrl": "URL for alert processing",
      "deduplicationGroupBy": "Deduplication Group By",
      "deduplicationGroupByHint": "Labels by which alerts will be grouped.",
      "deduplicationIgnore": "Deduplication Ignore Labels",
      "deduplicationIgnoreHint": "Labels that will be removed from alerts before processing.",
      "deduplicationPlaceholder": "Enter a label and press Enter",
      "apiBaseUrl": "API base url",
      "apiBaseUrlHint": "Monitoring address reachable from this instance network, formatted as http(s)://<host>[:<port>][/<path>]. If empty, the common system address is used."
    }
  },
  "s3Page": {
    "listEmpty": "S3 connectors list is empty",
    "listTitle": "S3 connectors",
    "newItem": "New S3 connector",
    "actions": {
      "checkConnection": "Check connection"
    },
    "formFields": {
      "label": "Name",
      "endpoint": "Endpoint",
      "bucket": "Bucket",
      "region": "Region",
      "prefix": "Prefix",
      "credentials": "Credentials",
      "accessKey": "Login",
      "secretKey": "Password",
      "secretKeyPlaceholder": "Leave unchanged",
      "verifySsl": "Verify certificate",
      "pathStyle": "Path-style: /bucket/key"
    },
    "test": {
      "successTitle": "Connection test succeeded",
      "successMessage": "Connection established",
      "successMessageWithStatus": "Connection established. HTTP status: {{status}}",
      "failureTitle": "Connection test failed",
      "failureMessage": "S3 returned HTTP status: {{status}}"
    }
  },
  "jobsPage": {
    "linkedVMAgents": "Linked VM agents",
    "listEmpty": "Jobs list is empty",
    "dialog": {
      "header": {
        "403": "Access denied",
        "405": "Job use active metrics of monitoring templates",
        "409": "Confirm job delete",
        "info": "All associated <strong>DISABLED</strong> metrics </br> will be deleted along with the task"
      },
      "notification": {
        "403": "User do not nave permission for this action",
        "405": "Disable metrics for job delete",
        "409": "Job delete would delete metrics in monitoring templates"
      },
      "metricName": "Label name",
      "job": "Job",
      "status": "Status",
      "disable": "Disable",
      "monitoringTemplateName": "Monitoring template name",
      "continue": "Continue",
      "delete": "Delete"
    },
    "formFields": {
      "name": "Name",
      "label": "Label",
      "validationType": "Validation type",
      "agents": "Metric collection agents",
      "tags": "Tags",
      "template": "Configuration",
      "notification": {
        "title": "The list of metric collection agents has been reset",
        "content": "Changing the validation type clears the list of selected metric collection agents. Please select them again."
      }
    }
  },
  "pluginsPage": {
    "tabs": {
      "downloaded": "Downloaded",
      "installed": "Installed"
    },
    "columns": {
      "name": "Name",
      "nameOfArchive": "Name of plugin archive",
      "size": "Size",
      "version": "Version",
      "time": "Created at",
      "actions": "Actions",
      "displayName": "Display name",
      "contentType": "Content type"
    },
    "tooltips": {
      "install": "Install",
      "installOnRunner": "Install on runner",
      "download": "Download",
      "deletePlugin": "Delete",
      "deinstallWarning": "Do you confirm deinstallation of the plugin?"
    },
    "installModal": {
      "alreadyExists": "Selected plugin already installed",
      "reinstallPlugin": "Reinstall plugin?"
    }
  },
  "enrichment-statistics": {
    "title": "Enrichment statistics"
  },
  "monitoringTemplateTabs": {
    "scopeOfApplication": "Scope of application",
    "metrics": "Metrics",
    "hi": "Health indicators"
  },
  "notifications": {
    "alertManagerTitle": "Alert Manager",
    "inhibitRulesTitle": "Inhibit rules",
    "templatesTitle": "Templates",
    "notificationsGeneralTitle": "General settings"
  },
  "deletePolicyTab": {
    "mode": "What to do with CIs marked for deletion",
    "modePeriod": "Delete after period",
    "modeForever": "Keep forever",
    "keepDays": "Keep after marking for deletion",
    "days": "days",
    "zeroHint": "The CI will be deleted on the next task run, restoring it during enrichment is effectively disabled",
    "restoreTitle": "A deleted CI can be restored",
    "restoreHint": "Until the period ends, enrichment can find the CI again - it comes back with its identifier, history and links. After physical deletion restoring is impossible.",
    "compositionTitle": "The composition owner overrides this period",
    "compositionHint": "CIs of this type belong to the composition: {{ciTypes}}. When the composing CI is physically deleted, all of its parts are deleted with it - regardless of the period and mode set here. The period only applies to CIs deleted separately from their owner.",
    "waitingOwn": "Awaiting deletion, own type",
    "waitingChildren": "Awaiting deletion, child CI types",
    "deleteNow": "Delete now",
    "deleted": "CIs deleted: {{count}}",
    "deleteDialog": {
      "title": "Delete marked CIs",
      "description": "All CIs of this CI type that have a deletion date will be physically deleted without waiting for the retention period to end.",
      "withChildren": "Delete CIs of child CI types",
      "warningTitle": "This action cannot be undone",
      "warning": "CIs to be deleted: {{count}}, along with everything they contain by composition."
    },
    "aliveOwn": "Active CIs, own type",
    "aliveChildren": "Active CIs, child CI types",
    "deleteSection": "Deleting CIs",
    "deleteSectionHint": "CIs are first marked for deletion and only then deleted physically - by the retention period or by 'Delete now'.",
    "markAll": "Mark all for deletion",
    "marked": "CIs marked for deletion: {{count}}",
    "markAllDialog": {
      "title": "Mark all CIs for deletion",
      "description": "All active CIs of the '{{ciType}}' CI type will be marked for deletion along with their parts. CIs that are already marked stay as they are - their retention period does not start over.",
      "withChildren": "Mark CIs of child CI types",
      "withChildrenHint": "{{types}} CI types · {{count}} CIs",
      "columnCiType": "CI type",
      "columnCiCount": "CIs",
      "groupOwn": "Own CI type",
      "groupChildren": "Child CI types",
      "groupComposed": "Parts - marked along with their owner",
      "alreadyMarked_one": "{{count}} more is already marked for deletion - it stays as it is",
      "alreadyMarked_other": "{{count}} more are already marked for deletion - they stay as they are",
      "noOwnCis": "The CI type has no active CIs - tick the checkbox above to mark CIs of child CI types",
      "via": "through '{{ciType}}'",
      "total": "To be marked in total",
      "timingTitle": "CIs will be deleted physically later",
      "timingForeverTitle": "This CI type keeps marked CIs forever",
      "timingPeriod_one": "In {{count}} day - the retention period of the '{{ciType}}' CI type - or right away by 'Delete now'.",
      "timingPeriod_other": "In {{count}} days - the retention period of the '{{ciType}}' CI type - or right away by 'Delete now'.",
      "timingZero": "On the next run of the deletion task or right away by 'Delete now'.",
      "timingForever": "They can only be deleted physically by 'Delete now'.",
      "timingChildren": "Child CI types have their own periods.",
      "timingComposed": "Parts will be deleted along with their owner.",
      "timingRestore": "Until the CIs are deleted, enrichment can find them again and bring them back with their identifier, history and links; there is no restore button.",
      "confirmLabel": "To confirm, type the system name of the CI type: {{ciType}}",
      "confirmError": "Does not match the system name of the CI type",
      "submit": "Mark for deletion",
      "notWritableTitle": "No rights to some of the CIs",
      "notWritable": "The SRM access rules do not allow you to change CIs: {{count}}. All CIs can be marked only when you are allowed to change every one of them."
    }
  },
  "adminNotifications": {
    "columns": {
      "owner": "Owner",
      "state": "State"
    },
    "filters": {
      "searchSubscription": "Name or system name",
      "searchReceiver": "Receiver name",
      "sender": "Sender",
      "problemsOnly": "Problems only"
    },
    "senderTypes": {
      "EMAIL": "Email",
      "TELEGRAM": "Telegram",
      "WEBHOOK": "Webhook"
    },
    "subscriptions": {
      "title": "Health indicator subscriptions",
      "columns": {
        "label": "Name",
        "hi": "Health indicator",
        "severities": "Severity",
        "receiver": "Receiver",
        "delivery": "Delivery"
      },
      "receiverDeleted": "receiver deleted",
      "hiUnavailable": "link unavailable",
      "bell": "In browser",
      "undelivered": "Not delivered",
      "undeliveredNoReceiver": "no receiver, browser notifications off",
      "undeliveredNoChannel": "receiver has no active channels",
      "deleteTitle": "Delete the subscription? Its owner will stop receiving notifications.",
      "actions": {
        "card": "Subscription details",
        "goToTemplate": "Open the indicator in the template"
      },
      "card": {
        "title": "Subscription «{{label}}»",
        "systemName": "System name",
        "template": "Monitoring template",
        "node": "TQL node",
        "bell": "Browser notifications",
        "groupBy": "Group notifications",
        "groupWait": "Group wait",
        "groupInterval": "Group interval",
        "repeatInterval": "Repeat interval",
        "extendMatchers": "Extended event filter"
      },
      "enableConfirm": {
        "title_one": "Enable {{count}} subscription",
        "title_other": "Enable {{count}} subscriptions",
        "warning_one": "{{count}} subscription will not be delivered",
        "warning_other": "{{count}} subscriptions will not be delivered",
        "description": "They have no receiver and browser notifications are off — the route will not reach the Alertmanager configuration.",
        "replayHint": "After enabling, the service replays current indicator states for the subscription owners."
      },
      "deleteManyTitle_one": "Delete {{count}} subscription? Its owner will stop receiving notifications.",
      "deleteManyTitle_other": "Delete {{count}} subscriptions? Their owners will stop receiving notifications."
    },
    "receivers": {
      "title": "User receivers",
      "columns": {
        "channels": "Delivery channels",
        "subscriptions": "Subscriptions"
      },
      "noChannels": "no channels configured",
      "senderDisabled": "sender disabled",
      "active": "Active",
      "noActiveChannels": "No active channels",
      "deleteTitle": "Delete the receiver?",
      "forceDelete": {
        "modalTitle": "Deleting receiver «{{name}}»",
        "title": "The receiver is used by active subscriptions",
        "description": "Delete or repoint these subscriptions, or confirm a forced delete — they will be left without a receiver and stop delivering notifications.",
        "submit": "Delete anyway"
      }
    }
  }
}